<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MsWR6g/tc-custom/9781402793301.jpg?1736625772182" alt="This image is the cover for the book Essential New York Times Grilling Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Essential New York Times Grilling Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <b>Get fired up with recipes and essays from Craig Claiborne, Mark Bittman, Jacques Pépin, Florence Fabricant, Sam Sifton, and other culinary superstars!</b><br/><br/>Over the past century, the <i>New York Times</i> has published thousands of articles on barbecuing and grilling, along with mouthwatering recipes—and this unique collection gathers the very best. These essential pieces are worth savoring not only for their time-tested advice and instruction, but also for the quality of the storytelling: Even non-cooks will find them a delight to read. <br/><br/>Almost all of the newspaper’s culinary “family” weighs in here, along with both renowned chefs and everyday tailgaters. The famous names include bestselling author Mark Bittman, who contributes the foreword as well as several essays and recipes; pioneer food critic Craig Claiborne (“French Thoughts on U.S. Barbecue”), Pierre Franey (Loin Lamb Steaks with Rosemary), the beloved Florence Fabricant (Raspberry Chocolate Mousse Cakes), Jacques Pépin (Grilled Tabasco Chicken), Molly O’Neill (“Splendor in the Lemongrass”), Alfred Portale, Mimi Sheraton, Sam Sifton, and many more. With everything from barbecue basics to expert tips, from healthy vegetarian fare to heart-attack-inducing meaty indulgences, this “eclectic selection of outdoor cooking recipes and stories” <br/><br/>is a treat for everyone (<i>Publishers Weekly</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Kaminsky, Mark Bittman
      </h2>
      
      <p class="authorDescription body article">Peter Kaminsky is a former columnist for the New York Times and a contributor to Food & Wine magazine. He has written, coauthored, or contributed to numerous books, his most recent being Bacon Nation: 125 Irresistible Recipes, with Marie Rama (Workman). Other titles include Pig Perfect: Encounters with Remarkable Swine and Some Great Ways to Cook Them (Hyperion) and Culinary Intelligence: The Art of Eating Healthy (and Really Well) (Vintage), which Jamie Oliver called “a great guide to how to make the most of your food.” He lives in Brooklyn, NY. Follow Peter on Twitter at @peterkaminsky.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2cbb299b